import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AdsService } from '../../services/ads.service';

@Component({
  selector: 'app-managepackages',
  templateUrl: './managepackages.component.html',
  styleUrls: ['./managepackages.component.scss']
})
export class ManagepackagesComponent implements OnInit {
  packages:any;
  cancellationReason: boolean;
  cancellationReasonForm: FormGroup;
  cancellationArray:any = [];
  submitted = false;
  packageForm:FormGroup;
  edit: boolean = false
  save: boolean = true
  disable: boolean = true

  constructor(private adsService: AdsService, private formBuilder: FormBuilder) { }

  ngOnInit(): void {
    this.packageForm = this.formBuilder.group({
      name: '',
      days: '',
      cost: ''
    });
    this.adsService.getPackages().then((res:any) => {
      console.log(res)
      this.packages=res.packages
      console.log(this.packages)
      this.packages = this.packages.map(item => ({
        ...item,
        showMore:true,
      }));
      console.log(this.packages)

    })
  }

  showCancellation(id) {
    this.cancellationReason = true;
    this.cancellationArray.id = id;
    console.log(this.cancellationArray.id)

  }

  hideCancellation() {
    this.cancellationReason = false;
    this.submitted = false;
    // this.cancellationReasonForm.reset();
  }

  deleteAd(){
    this.adsService.deleltePackage(this.cancellationArray.id).then((res) => {
      console.log(res);
      for (let i=0; i<this.packages.length; i++) {
        if (this.packages[i].id === this.cancellationArray.id){
          this.packages.splice(i,1);
        }
      }
      this.cancellationReason = false;
    })
  }

  editPackage(element){
    console.log(element)
    let data : any = []
    data.push({"name": element.name, "days": element.days, "cost": element.cost})
    console.log(data) 
    data= data[0]
    this.adsService.updatePackage(element.id, data).then((res:any) => {
      console.log(res)
      if(res.success){
        console.log("success")
        element.showMore=true
      }
    })
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }
  change(id){
    console.log(id)
    // this.edit=true;
    // this.save=false;
    // this.disable=false
    for(let i=0;i<this.packages.length; i++){
      if(this.packages[i].id == id){
        this.packages[i].showMore = false;
      }
    }
  }

  submitPackage(){
    var formData: FormData = new FormData();

    formData.append("name", this.packageForm.get('name').value);
    formData.append("days", this.packageForm.get('days').value);
    formData.append("cost", this.packageForm.get('cost').value);

    this.adsService.addPackage(formData).then((res:any) => {
     if(res.success){
      console.log(res)
      this.packageForm.reset();
      this.adsService.getPackages().then((res:any) => {
        this.packages=res.packages
        this.packages = this.packages.map(item => ({
          ...item,
          showMore:true,
        }));
      })
     }
     else{
       alert(res.error)
     }
    })
  }
}
